<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/AccountingProduct/Form'

export default {
    name: 'AccountingProductCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.accounting-products.store'))
        }
    }
}
</script>
